
import { gateway } from '../../api';

const CORE = process.env.REACT_APP_CORE;

export function buscarProcessos(numeroProcesso) {
  return gateway.get(`${CORE}/acordo-seguro/processos/${numeroProcesso}/inspecionar`);
}
